import { EApplication } from "@tm/models"

export const getTruckTyreApplicationTextId = (application?: EApplication) => {
    switch (application) {
        case EApplication.long:
        case EApplication.longHaul:
            return 14076
        case EApplication.regional:
            return 14056
        case EApplication.city:
            return 13967
        case EApplication.construction:
            return 13966
        case EApplication.mixed:
            return 13968
        default:
            return null
    }
}
